import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgMoreIconSecondary from './svgs/MoreIconSecondary.js';
import SvgMoreIcon from './svgs/MoreIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var moreIcon = (props => useIcon(SvgMoreIcon, SvgMoreIconSecondary, props));

export { moreIcon as default };
